module.exports = __webpack_public_path__ + "img/horizontal_4_3_8019.42ec10fd.png";